//
// map.js
// Theme module
//

const maps = document.querySelectorAll("[data-map]");
const accessToken =
  "pk.eyJ1IjoieWFuMzMyMSIsImEiOiJja3Y4NmZrcWEyMHhlMm9xcHE0enB1NjdsIn0.yK8ZLSrUe1uR1nD5xnM-qQ";

maps.forEach((map) => {
  const elementOptions = map.dataset.map ? JSON.parse(map.dataset.map) : {};

  const defaultOptions = {
    container: map,
    style: "mapbox://styles/mapbox/light-v9",
    scrollZoom: false,
    interactive: false,
  };

  const options = {
    ...defaultOptions,
    ...elementOptions,
  };

  // Get access token
  mapboxgl.accessToken = accessToken;

  // Init map
  new mapboxgl.Map(options);
});
